import React from 'react';

export default function MenuButton({ isMenuOpen, onClick }) {
    const isOpen = isMenuOpen ? '--open' : '';
    return (
        <div className={`menu-button`} onClick={onClick}>
            <div className={`menu-button__stripe menu-button__1stripe${isOpen}`} />
            <div className={`menu-button__stripe menu-button__2stripe${isOpen}`} />
            <div className={`menu-button__stripe menu-button__3stripe${isOpen}`} />
        </div>
    );
}
